import React, { Component, PropTypes } from 'react';
import { connect } from 'Util/refluxConnector';
import { StoreOverviewStore, AuthStore } from 'stores';
import { IconButton } from 'material-ui';
import { StoreOverviewActions } from 'actions';
import AppPage from 'Cio/AppPage';
import Checkout from 'components/Checkout';
import { Units, Colors, Shadow } from 'Css';
import * as SvgIcons from 'components/Material/SvgIcons';
import { AppStateActions } from 'entities/AppState';
import { getCart, isGift } from 'selectors/store';

const styles = {
  iconButton: {
    flex: '0 1',
    border: 18,
    padding: 20,
    width: 64,
    height: 64
  }
};

const css = oxygenCss({
  root: {
    maxWidth: Units.base * 120,
    '@phone': {
      maxWidth: Units.base * 60
    },
    margin: `${Units.base * 2}px auto`,
    borderRadius: Units.base / 2,
    backgroundColor: Colors.theme.Light.card,
    boxShadow: Shadow[1],
    boxSizing: 'border-box',
    padding: Units.base / 2,
    zIndex: 1
  },
  header: {
    backgroundColor: Colors.theme.Light.card,
    boxShadow: Shadow[1],
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    zIndex: 2
  }
});

class CheckoutContainer extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  constructor(props) {
    super(props);
    StoreOverviewActions.addCart(this.props.params.type, this.props.params.id, this.props.params.username)
    StoreOverviewActions.read(this.props.params.username);
  }

  componentDidMount() {
    if (!this.props.countryCode) {
      StoreOverviewActions.read(this.props.params.username);
    }
  }

  render() {
    const { username } = this.props.params;
    const { owner, loggedIn, toggleMainMenu } = this.props;
    const header = (
      <div className={css.header}>
        {loggedIn && (
          <IconButton style={styles.iconButton} onTouchTap={toggleMainMenu}>
            <SvgIcons.NavigationMenu
              color={'rgba(0, 0, 0, 0.9)'}
              hoverColor={'rgba(0, 0, 0, 0.5)'}
            />
          </IconButton>
        )}
      </div>
    );

    return (
      <AppPage header={header}>
        <div className={css.root}>
          <Checkout {...this.props} />
        </div>
      </AppPage>
    );
  }
}

export default connect(
  [
    [
      StoreOverviewStore,
      state => {
        const cart = getCart(state);
        return {
          cart: cart,
          isGift: isGift(state),
          name: state.name,
          activeDiscountCount: state.activeDiscountCount,
          paymentCompleted: state.payment.completed,
          open: cart.length > 0 && !isGift(state),
          method: state.payment.method,
          countryCode: state.countryCode,
          allowedPaymentProviders: state.allowedPaymentProviders,
          owner: state.owner
        };
      }
    ],
    [
      AuthStore,
      state => ({
        loggedIn: state.loggedIn
      })
    ]
  ],
  {
    setPaymentMethod: StoreOverviewActions.setPaymentMethod,
    toggleMainMenu: AppStateActions.toggleMainMenu
  }
)(CheckoutContainer);



// WEBPACK FOOTER //
// ./src/js/containers/Checkout.js